export enum AnalyticsEventType {
  CONTENT_VIEW = 'content_view',
  CONTENT_DOWNLOAD = 'content_download',
  CONTENT_SHARE = 'content_share',
  COLLECTION_VIEW = 'collection_view',
  COLLECTION_SHARE = 'collection_share',
  COLLECTION_CREATE = 'collection_create',
  USER_LOGIN = 'user_login',
  SHARED_LINK_OPEN = 'shared_link_open',
}

export enum ContentType {
  DOCUMENT = 'document',
  IMAGE = 'image',
  VIDEO = 'video'
}

export interface BaseAnalyticsEvent {
  user_id: string;
  user_group?: string;
  timestamp: number;
}

export interface ContentViewEvent extends BaseAnalyticsEvent {
  content_id: string;
  content_name: string;
  content_type: ContentType;
  content_url: string;
  product_id?: string;
  product_name?: string;
  collection_id?: string;
  collection_name?: string;
  file_extension?: string;
}

export interface ContentDownloadEvent extends ContentViewEvent {
  file_size?: number;
  download_method: 'direct' | 'browser';
}

export interface ContentShareEvent extends ContentViewEvent {
  share_link: string;
  share_type: 'collection' | 'asset';
}

export interface CollectionEvent extends BaseAnalyticsEvent {
  collection_id: string;
  collection_name: string;
  is_public: boolean;
  items_count: number;
}

export interface UserLoginEvent extends BaseAnalyticsEvent {
  login_time: number;
  device_type: 'mobile' | 'tablet' | 'desktop' | 'electron';
  platform: 'ios' | 'android' | 'web';
}

export interface SharedLinkOpenEvent {
  viewer_type: 'authenticated' | 'guest';
  content_id: string;
  content_type: 'asset' | 'collection';
  content_name: string;
  timestamp: number;
  referrer?: string;
}

// Tipo unione per tutti gli eventi
export type AnalyticsEventData = 
  | ContentViewEvent 
  | ContentDownloadEvent 
  | ContentShareEvent 
  | CollectionEvent 
  | UserLoginEvent 
  | SharedLinkOpenEvent;